import Vue from 'vue'
import Vuex from 'vuex'
import moment from 'moment';

Vue.use(Vuex)

var options = window.options

var apiUrl = options && options.apiUrl ? options.apiUrl + 'graphql' : 'http://snmcac.test/graphql/';
// var apiUrl = 'http://snmcac.test/graphql/';


export default new Vuex.Store({
  state: {
    filters: [],
    events: [],
    filteredEvents: [],
    dateContext: {},
    eventCount: 0,
    selectedFilters: [],
    selectedDate: moment.unix(),
    textFilter: '',
    currentDate: [moment().startOf('month').unix(), moment().endOf('month').unix()],
    timeSpan: 'month',
    debug: true,
    importantDates: [],
    loaded: false,
    downloadLinks: []
  },
  getters: {
    allEvents: (state) => state.events,
    allFilters: (state) => state.filters,
  },
  mutations: {
    SET_EVENTS(state, payload) {
      state.events = payload
    },
    SET_STATUS(state, payload) {
      state.loaded = payload
    },
    SET_FILTERS(state, payload) {
      state.filters = payload
    },
    SET_TIMESPAN(state, payload) {
      state.timeSpan = payload
    },
    SET_CURRENT_DATE(state, payload) {
      state.currentDate = payload
    },
    SET_SELECTED_FILTERS(state, payload) {
      state.selectedFilters = payload
    },
    SET_FILTERED_EVENTS(state, payload) {
      state.filteredEvents = payload
    },
    SET_TEXT_FILTER(state, payload) {
      state.textFilter = payload
    },
    SET_EXTRAS(state, payload) {
      state.importantDates = JSON.parse(payload.important_dates);
      state.downloadLinks = JSON.parse(payload.download_links);
    },
  },
  actions: {
    setTimespan({ commit }, timespan) {
      commit('SET_TIMESPAN', timespan);
    },
    setSelectedFilters({ commit }, payload) {
      commit('SET_SELECTED_FILTERS', payload)
    },
    setFilteredEvents({ commit }, payload) {
      commit('SET_FILTERED_EVENTS', payload)
    },
    setTextFilter({ commit }, payload) {
      commit('SET_TEXT_FILTER', payload.toLowerCase())
    },
    setCurrentDate({ commit }, payload) {
      var span = typeof payload.span === 'undefined' ? 'day' : payload.span;
      let dateToBeSet = payload.date;

      if (!Array.isArray(payload.date)) {
        dateToBeSet = [payload.date, payload.date];
      }
      // Set timespan to be a day since we're targeting a single date.
      commit('SET_CURRENT_DATE', dateToBeSet);
      commit('SET_TIMESPAN', span);
    },
    // resetSelectedFilters({ commit }, payload) {
    //   commit('SET_TIMESPAN', 'month');
    //   commit('SET_CURRENT_DATE', [moment().unix(), moment().unix()]);
    //   commit('SET_SELECTED_FILTERS', payload);
    //   // Defaults
    //   // this.setSelectedFilters(filters);
    //   // this.setCurrentDate([moment(), moment()], 'month');
    // },

    loadEvents({
      commit
    }, dates) {

      window.axios.post(apiUrl, {
        query: `{
            events(first: 100, after: null, where:{
              startDate: ${dates.start},
              endDate: ${dates.end}
            }) {
              pageInfo {
                hasPreviousPage
                hasNextPage
                startCursor
                endCursor
              }
              edges {
                node {
                  id
                  eventId
                  title
                  slug
                  link
                  thumbnail
                  thumbnail_url
                  info {
                    location
                    description
                    featured
                  }
                  dates {
                    startDate
                    endDate
                    allDay
                    startTime
                    endTime
                  }
                  gCalUrl
                  iCalUrl
                  eventCategories {
                    edges {
                      node {
                        id
                        name
                        slug
                      }
                    }
                  }
                }
              }
            }
		      }`
      }).then(response => {
        console.log(response.data.data.events.edges);
        commit('SET_EVENTS', response.data.data.events.edges);
        commit('SET_STATUS', true);
      })
    }
  }
})